import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { PrintDoc } from "./PrintReceipt";

export default function PrintInvoice() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/invoices/${id}`).then(({ data }) => setD(data)); }, [id]);
  if (!d) return <div className="p-10">Memuat...</div>;
  return <PrintDoc doc={d} kind="invoice" />;
}
